<template>
  <v-container small>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="0">
          <v-card-title class="text-wrap">
            <div class="display-1 font-weight-light text--primary text-break">New User</div>
          </v-card-title>
          <v-card-subtitle>We're excited you're here! Let's get started by getting your login information.</v-card-subtitle>
          <v-card-text>
            <v-stepper vertical v-model="newUserStep" class="elevation-0">
              <v-stepper-step step="1" :complete="newUserStep > 1">Identify Yourself</v-stepper-step>
              <!-- Step 1 -indentifyForm -->
              <v-stepper-content step="1">
                <v-form ref="indentifyForm" v-model="identityValid">
                  <v-card tile elevation="0" :loading="loadingAcct">
                    <v-card-text class="pb-0">
                      <p class="mb-0 text-h6">Please enter your email address</p>
                      <div class="mb-3">This is the email you provided your employer.</div>
                      <a @click="altIdentify = true" class="subtitle-1" link text color="primary">I don't know my email</a>
                      <div class="mt-5">
                        <v-text-field
                          type="email"
                          name="email"
                          :disabled="loadingAcct"
                          @blur="resetBlurValid"
                          prepend-inner-icon="mdi-email"
                          @keydown.enter.prevent="findAccountUser"
                          :rules="emailRules"
                          label="Email Address"
                          outlined
                          v-model="emailAddress"
                          required
                        ></v-text-field>
                      </div>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                      <v-row dense>
                        <v-col cols="12">
                          <template>
                            <vue-recaptcha
                              @verify="captAction(true)"
                              @expired="captAction(false)"
                              sitekey="6Le37CUTAAAAAIjclCmXF2YLjBSpk0d3wiO9Qp7y"
                              :loadRecaptchaScript="true"
                            ></vue-recaptcha>
                          </template>
                        </v-col>
                        <v-col cols="12">
                          <v-btn
                            :loading="loadingAcct"
                            @click="findAccountUser"
                            :disabled="!identityValid || !captOk"
                            color="primary"
                            depressed
                            min-width="125px"
                            width="50%"
                          >
                            Find account
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-stepper-content>

              <!-- Step 2 Email Check-->
              <v-stepper-step step="2" :complete="newUserStep > 2">Email Check</v-stepper-step>
              <v-stepper-content step="2">
                <v-slide-y-transition mode="out-in">
                  <template v-if="loadingEmails">
                    <v-progress-circular color="deep-purple accent-4" indeterminate></v-progress-circular>
                  </template>
                  <template v-if="!loadingEmails && emailList.length > 1">
                    <div>
                      <label class="font-weight-bold">Where should send your Username?</label>
                      <v-radio-group v-model="selectedEmail">
                        <v-radio v-for="item in emailList" :key="item.email_type" :label="item.semail" :value="item.semail"></v-radio>
                      </v-radio-group>
                    </div>
                  </template>
                </v-slide-y-transition>
                <v-slide-y-transition>
                  <v-card-actions v-if="emailList.length > 1 && !loadingEmails">
                    <v-btn outlined color="primary" @click="passwordStep = 1" :disabled="loadingAcct">Back</v-btn>
                    <v-btn :disabled="selectedEmail == null" depressed color="primary" :loading="loadingAcct" @click="sendUsername1(selectedEmail)">
                      Next
                    </v-btn>
                  </v-card-actions>
                </v-slide-y-transition>
              </v-stepper-content>

              <!-- Step 3 Sending Username-->
              <v-stepper-step step="3" :complete="newUserStep > 3">Sending Username</v-stepper-step>
              <v-stepper-content step="3">
                <template v-if="usernameSending">
                  <v-progress-circular color="deep-purple accent-4" indeterminate></v-progress-circular>
                </template>
              </v-stepper-content>

              <!-- step 4 Sending Password -->
              <v-stepper-step step="4" :complete="newUserStep > 4">Sending Password</v-stepper-step>
              <v-stepper-content step="4">
                <template v-if="passwordSending">
                  <v-progress-circular color="deep-purple accent-4" indeterminate></v-progress-circular>
                </template>
              </v-stepper-content>

              <!-- Step 5 Confirmation-->
              <v-stepper-step step="5" :complete="newUserStep > 5">Confirmation</v-stepper-step>
              <v-stepper-content step="5">
                <v-card>
                  <v-card-text>
                    <template v-if="userPassResult == 1">
                      <p v-if="emailList.length > 0">
                        Your Username and Password have been sent to
                        <b>{{ chosenEmail }}</b>
                        in two separate emails. Please remember to check your "spam" or "junk" folder for this email. If you don't receive this email
                        within 15 minutes,
                        <!-- {{ emailList[0].service_msg }} 06/03/2024 ACCTMG-4966- pass dynamic message from database as html text-->
                        <span v-html="emailList[0].service_msg"></span>
                        <a :href="'tel:' + emailList[0].service_phone">{{ emailList[0].service_phone }}</a>
                        {{ emailList[0].service_hours }}.
                      </p>
                      <p v-else>
                        Your Username and Password have been sent to
                        <b>{{ chosenEmail }}</b>
                        in two separate emails. Please remember to check your "spam" or "junk" folder for this email. If you don't receive this email
                        within 15 minutes,you may call our Client Services department at
                        <a href="tel:+1.800.945.5513">1.800.945.5513</a>
                        .
                      </p>
                      <!-- 04/30/2024 ACCTMG-5602 - pass different message for account vise --- -->
                      <!-- If you don't receive these
                        emails within 15 minutes, you may call our Client Services department at
                        <a href="tel:+1.800.945.5513">1.800.945.5513</a>
                        .
                      </p> -->
                    </template>
                    <template v-else>
                      <div>
                        <p>
                          We're sorry, but it looks like the email address we have associated to your record has not yet been verified. We've resent
                          you a verification request so you can complete your email verification. Upon your completion of the Verification process,
                          you will receive your User Name.
                        </p>

                        <p v-if="emailList.length > 0">
                          <!-- If you do not receive an email within 30 minutes, please call
                          <a href="tel:+1.800.945.5513">1.800.945.5513</a>
                          Monday - Friday 8:30 AM - 5:00 PM Eastern Time. -->
                          If you do not receive an email within 30 minutes,
                          <!-- {{ emailList[0].service_msg }} 06/03/2024 - pass dynamic message from database as html text-->
                          <span v-html="emailList[0].service_msg"></span>
                          <a :href="'tel:' + emailList[0].service_phone">{{ emailList[0].service_phone }}</a>
                          {{ emailList[0].service_hours }}.
                        </p>
                        <p v-else>
                          If you do not receive an email within 30 minutes, please call
                          <a href="tel:+1.800.945.5513">1.800.945.5513</a>
                          Monday - Friday 8:30 AM - 5:00 PM Eastern Time.
                        </p>
                      </div>
                    </template>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn outlined color="primary" :href="getHome">Back to Login</v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
        </v-card>
        <v-dialog v-model="altIdentify" persistent max-width="600px">
          <altIdentifyDialog
            ref="altIdentification"
            :alt-dialog="altIdentify"
            @alt-dialog="handleAltDialog"
            @alt-inputs="altinputsvalue"
            @alt-success="altProcess"
          />
        </v-dialog>

        <!--#region 05/17/2023-Lakshmi - Ticket ACCTMG-4113 -->
        <template v-if="emailList != ''">
          <v-dialog v-model="addNewEmail" persistent max-width="350">
            <v-window v-model="newEmailStep">
              <v-window-item :value="1">
                <v-card :loading="submittingNewEmail">
                  <v-card-title class="headline pink--text accent-4">Verified Email not Found</v-card-title>
                  <v-form ref="newEmailForm" v-model="validNewEmail">
                    <v-card-text>
                      We were unable to find a verified email for your account. To gain access to your account, you must enter and verify an email
                      address.
                      <v-divider class="my-4"></v-divider>
                      <v-text-field
                        type="email"
                        name="email"
                        :disabled="submittingNewEmail"
                        @blur="resetBlurValid"
                        prepend-inner-icon="mdi-email"
                        @keydown.enter.prevent="addPendedEmail"
                        :rules="emailRules"
                        label="Email Address *"
                        outlined
                        v-model="newEmail"
                        required
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue-grey darken-3"
                        text
                        @click="
                          addNewEmail = false;
                          newEmail = '';
                        "
                      >
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="addPendedEmail" :disabled="!validNewEmail" :loading="submittingNewEmail">Submit</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-window-item>
              <v-window-item :value="2">
                <v-card :loading="verifyingEmail">
                  <v-card-title class="headline font-weight-light">Almost there...</v-card-title>
                  <v-card-text>
                    We've sent an email to
                    <b>{{ newEmail }}</b>
                    that contains a 4 digit verification code. Keep this window open to enter the code below to complete the verification process.
                    <v-divider class="my-4"></v-divider>
                    <v-text-field
                      type="number"
                      inputmode="decimal"
                      :maxlength="4"
                      label="Verification Code"
                      outlined
                      hint="This is a 4 digit code that you received to complete the Verification Process"
                      persistent-hint
                      @keydown.enter.prevent="verifyPendedEmail"
                      :disabled="verifyingEmail"
                      v-model="verificationCode"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="verifyPendedEmail" :loading="verifyingEmail" :disabled="verificationCode.length < 4">
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>

                <!-- not verification code found Dialog -->
                <v-dialog v-model="codenotverified" persistent max-width="350">
                  <v-card>
                    <v-card-title class="headline pink--text accent-4">Code not found</v-card-title>
                    <v-card-text>We were unable to verify your code.</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <!-- <v-btn
                        color="blue-grey darken-3"
                        text
                        @click="
                          codenotverified = false;
                          altIdentify = true;
                        "
                      >
                        Resend code.
                      </v-btn> -->
                      <v-btn
                        color="primary"
                        text
                        @click="
                          codenotverified = false;
                          newUserStep = 1;
                        "
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-window-item>
            </v-window>
          </v-dialog>
        </template>
        <!-- endregion -->

        <!-- not found Dialog -->
        <v-dialog v-model="notFound" persistent max-width="350">
          <v-card>
            <v-card-title class="headline pink--text accent-4">Username not found</v-card-title>
            <v-card-text>
              We were unable to find any Username matching the email
              <b>{{ emailAddress }}</b>
              . Would you like to try again or find your Username using some other information?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-grey darken-3"
                text
                @click="
                  notFound = false;
                  altIdentify = true;
                "
              >
                Try another way.
              </v-btn>
              <v-btn color="primary" text @click="notFound = false">Try Again</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import altIdentifyDialog from "@/components/altIdentify";
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";
export default {
  name: "newUser",
  components: {
    altIdentifyDialog,
    VueRecaptcha,
  },
  data: function () {
    return {
      captOk: false,
      newUserStep: 1,
      notFound: false,
      altIdentify: false,
      identityValid: true,
      loadingEmails: false,
      emailAddress: "",
      loadingAcct: false,
      emailList: [],
      chosenEmail: "",
      selectedEmail: "",
      passwordSending: false,
      usernameSending: false,
      userPassResult: null,
      userName: "",
      emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
      newUserResult: null,
      //05/17/2023-Lakshmi
      addNewEmail: false,
      submittingNewEmail: false,
      newEmail: "",
      validNewEmail: true,
      verifyingEmail: false,
      verificationCode: "",
      addedRID: "",
      newEmailStep: 1,
      computedDateFormatted: "",
      ssnInput: "",
      zipInput: "",
      semail_: "",
      susername: "",
      codenotverified: false,
      emaillistvales: [],
    };
  },
  props: ["retrievalSelection"],
  watch: {
    emailAddress: function () {
      if (this.emailAddress == "") {
        this.resetValidation();
      }
    },
  },
  computed: {
    ...mapGetters(["getHome"]),
    home() {
      return this.$store.getters.getHome;
    },
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1 ||
        location.href.toLowerCase().indexOf("me360dev") > -1
        ? ""
        : "http://localhost";
    },
  },
  methods: {
    captAction(r) {
      var self = this;
      self.captOk = r;
    },
    //exitsting Procedure
    // altProcessold(value) {
    //   console.log("new user value : " + value);
    //   this.newUserStep = 2;
    //   this.loadingEmails = true;
    //   this.sendUsername(JSON.parse(value)[0].semail, JSON.parse(value)[0].username);
    //   this.altIdentify = false;
    // },

    //#region - copied from username.vue - 5/17/2023 - Ticket ACCTMG-4113(Fix issue with first time user)
    altProcess(value) {
      var self = this;
      this.emailList = value;
      this.newUserStep = 2;
      this.loadingEmails = true;
      this.altIdentify = false;
      if (value == 2) {
        self.addNewEmail = true;
        self.newEmailStep = 1;
        self.newEmail = "";
        self.verificationCode = "";
        self.loadingAcct = false;
        self.loadingEmails = false;
        self.verifyingEmail = false;
      } else if (value == 0) {
        self.notFound = true;
        self.newUserStep = 1;
        self.loadingAcct = false;
        self.loadingEmails = false;
      } else {
        //this.sendUsername(JSON.parse(value)[0].semail);
        this.sendUsername(JSON.parse(value)[0].semail, JSON.parse(value)[0].username);
      }
    },
    addPendedEmail() {
      var self = this;
      self.submittingNewEmail = true;

      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/AddEmailToPend", {
          u_dob: self.computedDateFormatted,
          u_ssn: self.ssnInput,
          u_zip: self.zipInput,
          new_email: self.newEmail,
        })
        .then(function (response) {
          if (response.data.d != "Failed") {
            self.submittingNewEmail = false;
            self.newEmailStep = 2;
            self.addedRID = response.data.d;
          } else {
            alert("Error");
            self.verifyingEmail = false;
          }
        });
    },
    verifyPendedEmail() {
      var self = this;
      self.verifyingEmail = true;
      self.usernameSending = true;
      self.loadingEmails = true;
      self.loadingAcct = true;
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/VerifyEmailSendUsername", {
          verify_rid: self.addedRID,
          auto_code: self.verificationCode,
        })
        .then(function (response) {
          if (response.data.d == "Sucess") {
            self.addNewEmail = false;
            self.loadingEmails = true;
            self.usernameSending = false;
            self.loadingAcct = true;
            self.newUserStep = 3;
            self.codenotverified = false;
            self.findAccountUserDetails();
          } else {
            //alert("Error");
            self.codenotverified = true;
            self.addNewEmail = false;
            self.loadingEmails = false;
            self.usernameSending = false;
            self.loadingAcct = false;
          }
        });
    },
    altinputsvalue(dat, ssn_, zip_) {
      this.computedDateFormatted = dat;
      this.ssnInput = ssn_;
      this.zipInput = zip_;
    },
    //#endregion

    handleRetrieveError(r) {
      this.$emit("retrieve-error", r);
      this.loadingAcct = false;
      this.loadingEmails = false;
    },
    handleAltDialog(value) {
      this.altIdentify = value;
    },

    altIdentifyPop() {
      this.altIdentify = true;
    },
    resetForm() {
      this.emailAddress = "";
      this.newUserStep = 1;
    },

    // Username find and send
    findAccountUser() {
      var self = this;
      if (self.identityValid) {
        this.loadingAcct = true;
        self.loadingEmails = true;
        self.usernameSending = true;
        axios
          .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/get_user_email", {
            user_email: self.emailAddress,
          })
          .then(function (response) {
            if (response.data.d == "NO Found") {
              self.loadingAcct = false;
              self.notFound = true;
            } else {
              self.emailList = JSON.parse(response.data.d);
              if (self.emailList.length >= 2) {
                self.loadingEmails = false;
                self.newUserStep = 2;
                self.loadingAcct = false;
                self.emaillistvales = self.emailList;
              } else {
                self.sendUsername(JSON.parse(response.data.d)[0].semail, JSON.parse(response.data.d)[0].username);
              }
            }
          })
          .catch(function (e) {
            self.loadingEmails = false;
            self.loadingAcct = false;
            self.notFound = true;
            console.log("findAccountUser " + e);
          });
      }
    },

    // This is added new - to get the username after email verified
    findAccountUserDetails() {
      var self = this;
      self.loadingAcct = true;
      self.loadingEmails = true;
      self.newUserStep = 3;
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/get_user_email", {
          user_email: self.newEmail,
        })
        .then(function (response) {
          if (response.data.d == "NO Found") {
            self.loadingAcct = false;
            self.notFound = true;
            console.log("findAccountUserDetails " + " NO Found");
          } else {
            //self.emailList = JSON.parse(response.data.d);
            self.identityValid = true;
            //console.log("findAccountUserDetails " + JSON.parse(response.data.d)[0].username);
            self.findAccountPass(JSON.parse(response.data.d)[0].semail, JSON.parse(response.data.d)[0].username);
          }
        })
        .catch(function (e) {
          self.loadingEmails = false;
          self.loadingAcct = false;
          self.notFound = true;
          console.log("findAccountUserDetails " + e);
        });
    },
    sendUsername1(selectedemail) {
      var result = this.emaillistvales.filter((val) => val.semail == selectedemail);
      if (result.length > 0) {
        this.sendUsername(selectedemail, result[0].username);
      }
    },

    sendUsername(r, s) {
      var self = this;
      self.usernameSending = true;
      self.chosenEmail = r;
      //console.log("sendUsername ", r, s);
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/SendUserName", {
          user_email: r,
        })
        .then(function (response) {
          if (response.data.d == "Email Not Verified") {
            self.newUserResult = 2;
            self.newUserStep = 5;
            self.loadingAcct = false;
            console.log("sendUsername " + "Email Not Verified");
          } else if (response.data.d == "Sucess") {
            self.newUserResult = 1;
            self.loadingAcct = false;
            self.usernameSending = false;
            self.identityValid = true;
            // console.log("sendUsername " + s);
            self.findAccountPass(r, s);
          }
        })
        .catch(function (error) {
          console.log(" error  sendUsername" + error);
          if (error.response) {
            console.log("there was an error sending the email.");
          }
        });
    },

    // Password find and send
    findAccountPass(r, s) {
      var self = this;
      self.newUserStep = 4;
      self.passwordSending = true;

      if (self.identityValid) {
        this.loadingAcct = true;
        self.loadingEmails = true;
        axios
          .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/GetUserEmail", {
            user_name: s,
          })
          .then(function (response) {
            // console.log("response.data.d " + response.data.d);
            if (response.data.d == "NO Found") {
              self.loadingAcct = false;
              self.notFound = true;
              self.newUserStep = 5;
              self.newUserResult = 2;
            } else {
              self.sendPassword(r, s);
              // if (self.emailList.length >= 2) {
              //   self.loadingEmails = false;
              //   self.loadingAcct = false;
              // } else {
              //   console.log("self.sendPassword" + r + s);
              //   self.sendPassword(r, s);
              // }
            }
          })
          .catch(function (e) {
            self.handleRetrieveError("Username");
            console.log("err " + e);
          });
      }
    },
    sendPassword(r, s) {
      var self = this;
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/SendUserPassword", {
          user_email: r,
          user_name: s,
        })
        .then(function () {
          self.newUserStep = 5;
          self.loadingAcct = false;
          self.passwordSending = false;
          self.userPassResult = 1;
        })
        .catch(function (error) {
          console.log(" sendPassword error " + error);
          if (error.response) {
            self.userPassResult = 2;
          }
        });
    },
    validate() {
      this.$refs.indentifyForm.validate();
    },
    resetValidation() {
      this.$refs.indentifyForm.resetValidation();
    },
    resetBlurValid() {
      if (this.emailAddress == "") {
        this.$refs.indentifyForm.resetValidation();
      }
    },
  },
};
</script>
